<template>
  <div ref="myEcharts" :style="{ height, width }"></div>
</template>
<script setup >
// props="['width','height','right1Data']"
name: "baseBar";
import { ref, onMounted,defineProps } from "vue";
import * as echarts from "echarts";
const props =defineProps({
  width: {
    type: String,
    default: "100%",
  },
  height: {
    type: String,
    default: "100%",
  },
  listData: {
    type: Array,
    default: () => [],
  },
})
// console.log(props.listData);
const myEcharts = ref(null);

onMounted(() => {
  // let data = [
  //   { value: 287.5, name: "2023年全县生产总值" },
  //   { value: 54.57, name: "第一产业增加值" },
  //   { value: 93.51, name: "第二产业增加值" },
  //   { value: 139.44, name: "第三产业增加值" },
  // ];
  initChart(props.listData);
});

function initChart(listData) {
  if (myEcharts.value && myEcharts.value.chart) {
    myEcharts.value.chart.dispose();
  }

  const chartInstance = echarts.init(myEcharts.value);
  let legendData = [];
  let seriesData = [];
  let colorArr = ['#00F6FF', '#FFB71D', '#1DFF5D'];
  legendData = listData.list.map((item) => item.name);
  seriesData = listData.list.map((item1, index1) => {
    return {
      name: item1.name,
      type: 'bar',
      barWidth: 15,
      silent: true,
      itemStyle: {
        normal: {
          color: colorArr[index1],
          // barBorderRadius: [30, 30, 0, 0],
        },
      },
      data: item1.value,
    }
  })


  const option= {
    grid: {
      containLabel: true,
      bottom: '5%',
      top: '20%',
      left: '5%',
      right: '5%',
    },
    tooltip: {
      trigger: 'axis',
      axisPointer: {
        type: 'shadow',
      },
      formatter: (params) => {
        let arr = [...params];
        let str = '';
        arr.forEach((item, index) => {
          str +=  item.seriesName + ' : ' + item.data + '万亩<br />';
        });
        str = arr[0].name + '<br />' + str;
        return str;
      },
    },
    legend: {
      orient: 'horizontal',
      top: '5%',
      right: '2%',
      data: legendData,
      itemWidth: 10,
      itemHeight: 3,
      itemGap: 40,
      icon: "rect",
      textStyle: {
        fontSize: 13,
        color: '#fff',
        padding: [5, 0, 0, 2],
        rich: {
          a: {
            verticalAlign: 'middle',
          },
        },
      },

    },
    xAxis: {
      triggerEvent: true,
      data: listData.time,
      axisLabel: {
        show: true,
        fontSize: 14,
        color: '#fff',
        align: 'center',
        verticalAlign: 'top',
      },
      axisLine: {
        show: false,
      },
      axisTick: {
        show: false,
      },
    },
    yAxis: [
      {
        name:"单位（万亩）",
        nameTextStyle:{
          color:"#fff",
          fontSize:14,
          padding:[0,0,15,0]
        },
        axisLabel: {
          interval: 0,
          show: true,
          fontSize: 14,
          color: '#fff',
        },
        axisLine: {
          show: true,
          lineStyle: {
            type: 'solid',
            color: '#324157',
          },
        },
        axisTick: {
          show: false,
        },
        splitLine: {
          lineStyle: {
            type: 'solid',
            color: '#324157',
          },
        },
      },
    ],
    series: seriesData,
  };// 将你的ECharts配置项放在这里
    chartInstance.setOption(option, true);
}
  window.addEventListener("resize", () => {
    chartInstance.resize();
  });

</script>
<style lang="less"></style>
